import { ColumnDef } from "@tanstack/react-table";
import { ResultBadge, EnumBadge } from "@/components/badges";
import { truncateText, formatDuration, formatDate, formatPersonName, formatEnumLabel } from "@/lib/formatters";
import { TRUNCATE_CASE_ID, TRUNCATE_CALL_ID } from "@/lib/constants";
import type { CallRow } from "@/types";

export const callColumns: ColumnDef<CallRow>[] = [
  {
    accessorKey: "caseId",
    header: "Case ID",
    cell: ({ row }) => (
      <span className="font-mono text-xs" title={row.original.caseId}>
        {truncateText(row.original.caseId, TRUNCATE_CASE_ID)}
      </span>
    ),
  },
  {
    accessorKey: "callId",
    header: "Call ID",
    cell: ({ row }) =>
      row.original.callId ? (
        <span className="font-mono text-xs" title={row.original.callId}>
          {truncateText(row.original.callId, TRUNCATE_CALL_ID)}
        </span>
      ) : (
        <span className="text-muted-foreground">-</span>
      ),
  },
  {
    accessorKey: "attemptIndex",
    header: "Attempt",
    cell: ({ row }) =>
      row.original.totalAttempts > 0 ? (
        <span className="font-medium">
          {row.original.attemptIndex + 1}/{row.original.totalAttempts}
        </span>
      ) : (
        <span className="text-muted-foreground">-</span>
      ),
  },
  {
    accessorKey: "timestamp",
    header: "Time",
    cell: ({ row }) => (
      <span className="text-sm">{formatDate(row.original.timestamp)}</span>
    ),
  },
  {
    id: "scheduledFor",
    header: "Scheduled call",
    cell: ({ row }) => (
      <span className="text-sm text-muted-foreground">
        {row.original.scheduledFor ? formatDate(row.original.scheduledFor) : "—"}
      </span>
    ),
  },
  {
    accessorKey: "memberName",
    header: "Patient",
    cell: ({ row }) => (
      <span>
        {formatPersonName(row.original.memberFirstName, row.original.memberLastName) || "-"}
      </span>
    ),
  },
  {
    accessorKey: "success",
    header: "Result",
    cell: ({ row }) => <ResultBadge success={row.original.success} />,
  },
  {
    accessorKey: "paStatus",
    header: "PA Status",
    cell: ({ row }) =>
      row.original.paStatus ? (
        <EnumBadge value={row.original.paStatus} />
      ) : (
        <span className="text-muted-foreground">-</span>
      ),
  },
  {
    accessorKey: "failReason",
    header: "Fail Reason",
    cell: ({ row }) =>
      row.original.failReason ? (
        <span className="text-sm text-muted-foreground">
          {formatEnumLabel(row.original.failReason)}
        </span>
      ) : (
        <span className="text-muted-foreground">-</span>
      ),
  },
  {
    accessorKey: "duration",
    header: "Duration",
    cell: ({ row }) => (
      <span className="text-sm">{formatDuration(row.original.duration)}</span>
    ),
  },
];
